export const JOYSTREAM_DEFAULT_CHAIN_ID = 'polkadot:6b5e488e0fa8f9821110d5c13f4c468a'
export const WC_VERSION = '2.0'

export const JOYSTREAM_SS58_PREFIX = 126
